<div class="title">{{ current }}</div>
<div class="crumbs" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
  <a [routerLink]="['/']" class="crumb home">Home</a>
  @for (crumb of crumbs; track crumb) {
    <div class="crumb" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <mat-icon class="chevron">chevron_right</mat-icon>
      <div class="link">{{ crumb }}</div>
    </div>
  }
  <div class="crumb current" style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
    <mat-icon class="chevron">chevron_right</mat-icon>
    <div class="link">{{ current }}</div>
  </div>
</div>
